import { __extends } from "tslib";
import React from 'react';
import { I18nextProvider, } from 'react-i18next';
import { i18nInit } from '../i18n';
import { SupportModal as SupportModalBase } from '../components/modals/support-modal/support-modal';
var SupportModal = /** @class */ (function (_super) {
    __extends(SupportModal, _super);
    function SupportModal(props) {
        return _super.call(this, props) || this;
    }
    SupportModal.prototype.render = function () {
        var appToModal = this.props.app.baseInfo
            ? { webSolutionBase: this.props.app.baseInfo }
            : this.props.app;
        var baseUrl = this.props.baseUrl;
        var origin = this.props.origin;
        var msId = this.props.msId;
        var authorizationHeader = this.props.authorizationHeader;
        var handleClose = this.props.closeModal;
        return (React.createElement("div", null,
            React.createElement(I18nextProvider, { i18n: i18nInit(this.props.locale) },
                React.createElement(SupportModalBase, { app: appToModal, msId: msId, origin: origin, closeModal: handleClose, authorizationHeader: authorizationHeader, baseUrl: baseUrl, clickSource: this.props.clickSource, pageName: this.props.pageName, showUserActionNotification: this.props.showUserActionNotification }))));
    };
    return SupportModal;
}(React.Component));
export { SupportModal };
//# sourceMappingURL=support-modal.js.map